import styled from 'styled-components';
import { GhostButton, GhostSuccessButton } from 'ui/button';
import { Body2, colors, Overline, spacing, Subtitle1, textColors } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';

export const Wrapper = styled.div`
  border: solid ${spacing.single} ${colors.grey15};
  border-radius: ${spacing.half};
  box-sizing: border-box;
  padding: ${spacing.double};
  &:not(:last-child) {
    margin-bottom: ${spacing.double};
  }
  &.hasBanner {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top-width: 0;
  }
`;

export const Main = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const AccountName = styled(Subtitle1)`
  margin-bottom: ${spacing.quarter};
`;

export const AccountDetails = styled(Body2)`
  color: ${colors.textSecondary};
`;

export const ArrowButton = styled(GhostButton)`
  & + * {
    margin-left: ${spacing.base};
  }
`;

export const LeftContent = styled.div`
  padding-right: ${spacing.double};
  & h5 {
    text-overflow: ellipsis;
    overflow: hidden;
    width: ${spacing.x16};
    white-space: nowrap;
    @media only screen and (max-width: 1005px) {
      width: ${spacing.x10};
    }
  }
`;

export const RightContent = styled.div`
  align-items: center;
  display: flex;
`;

export const ActionButton = styled(GhostSuccessButton)`
  margin-right: ${spacing.base};
`;

export const ConnectLink = styled.a`
  &:hover {
    text-decoration: none;
  }
`;

export const SectionHeading = styled(Overline)`
  color: ${colors.textSecondary};
  display: block;
  margin-bottom: ${spacing.threeQuarter};
  padding-top: ${spacing.plusHalf};
`;

export const StyledTooltip = styled(Tooltip)`
  cursor: default;
  text-decoration-color: ${textColors.textSecondary};
`;
